import * as React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'

export const RadioGroup = styled.div`
  min-height: 30px;
  font-size: 16px;
  align-self: start;
`
export const RadioGroupContact = (props) => (
  <RadioGroupArea>
    <RadioGroup>{props.children}</RadioGroup>
    {props.errorMessage && <ErrorArea>{props.errorMessage}</ErrorArea>}
  </RadioGroupArea>
)

const RadioGroupArea = styled.div`
  display: flex;
  flex-direction: column;
`

const ErrorArea = styled.p`
  color: #974353;
  font-size: 12px;
  font-weight: 700;
  margin: 0px 5px 3px;
`

interface Props {
  label: string
  name: string
  value: string
  defaultChecked?: boolean
  onClick?: (key) => void
  inline?: boolean
}

export const RadioButton = (props: Props) => {
  const { inline, label, name, onClick, value } = props
  return (
    <Label onClick={onClick} inline={inline}>
      <CustomRadioButton
        name={name}
        value={value}
        //defaultChecked={defaultChecked}
      />
      {inline ? <Inline>{label}</Inline> : <Stacked>{label}</Stacked>}
    </Label>
  )
}

const Label = styled.label`
  float: left;
  margin: 4px;
  font-weight: unset;
  cursor: pointer;
  ${(props) => !props.inline && 'width: 100%;'}
  p {
    font-size: 15px;
  }
`

const Stacked = styled.p`
  width: 90%;
  float: right;
  ${media.phone` width: 85%; `}
`

const Inline = styled.p`
  display: inline;
  width: 50%;
`

const CustomRadioButton = styled.input.attrs({ type: 'radio' })``

export default RadioButton



// WEBPACK FOOTER //
// ./src/components/atoms/input/RadioButton.tsx